// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resend-tooltip[data-v-9d920d20]{padding:0;border:none}.error-icon[data-v-9d920d20]{color:#ff392e;background-color:#fff;border-radius:50%;cursor:pointer;margin:0 5px 10px -10px}.error-icon[data-v-9d920d20]:before{font-size:18px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
